module.exports = __webpack_public_path__ + "img/3S.4fa0bbb2.png";